// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUYING_GUIDES_SHOW_LESS = "Zobraz menej sprievodcov";
export const BUYING_GUIDES_SHOW_MORE_count = "Zobraz \u010fal\u0161\u00edch sprievodcov (%(count)s)";
export const STROLLERS_BUYING_GUIDES_HEADER = "Modr\u00fd kon\u00edk \u0165a prevedie svetom ko\u010d\u00edkov";
